import { Component, Input } from '@angular/core';
import { EMFieldCombineType } from './typings';

@Component({
  selector: 'm-field-icon',
  template: `
    <ng-container [ngSwitch]="mType">
      <i nz-icon *ngSwitchCase="'combine'">
        <svg
          width="24px"
          height="22px"
          viewBox="0 0 24 22"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="表格/内容/组合" transform="translate(-43.000000, -13.000000)" fill-rule="nonzero">
              <g id="编组" transform="translate(17.000000, 12.000000)">
                <g id="编组" transform="translate(26.000000, 0.000000)">
                  <g id="文件夹" transform="translate(0.000000, 1.000000)" fill="#2596F9">
                    <path
                      d="M1.04977376,0 L9.94894198,0 C10.2202343,0 10.4809928,0.108263728 10.6765493,0.302093688 L13.6470588,3.24637681 L13.6470588,3.24637681 L0,3.24637681 L0,1.0821256 C0,0.484484135 0.469999719,0 1.04977376,0 Z"
                      id="形状结合"
                    ></path>
                    <path
                      d="M22.7484444,3.11111111 C23.4396595,3.11111111 24,3.67001852 24,4.35946575 L24,19.949713 C24,20.6391602 23.4396595,21.1980676 22.7484444,21.1980676 L1.25155556,21.1980676 C0.560340507,21.1980676 0,20.6391602 0,19.949713 L0,3.11111111 L22.7484444,3.11111111 Z"
                      id="矩形"
                    ></path>
                  </g>
                  <path
                    d="M17.0550921,12.3291343 L17.7413735,12.7407889 C17.827497,12.7923476 17.8802142,12.8853492 17.8802142,12.9857263 C17.8802142,13.0861033 17.827497,13.179105 17.7413735,13.2306636 L12.4401071,16.4114234 L7.13884074,13.2306636 C7.05271722,13.179105 7,13.0861033 7,12.9857263 C7,12.8853492 7.05271722,12.7923476 7.13884074,12.7407889 L7.82512207,12.3291343 L12.4401071,15.0982395 L17.0550921,12.3291343 Z M17.0550921,15.0125971 L17.7413735,15.4242517 C17.827497,15.4758103 17.8802142,15.568812 17.8802142,15.669189 C17.8802142,15.7695661 17.827497,15.8625677 17.7413735,15.9141264 L12.7341461,18.9184628 C12.5531936,19.0271791 12.3270206,19.0271791 12.1460681,18.9184628 L7.13884074,15.9141264 C7.05271722,15.8625677 7,15.7695661 7,15.669189 C7,15.568812 7.05271722,15.4758103 7.13884074,15.4242517 L7.82512207,15.0125971 L12.4401071,17.7817023 L17.0550921,15.0125971 L17.0550921,15.0125971 Z M12.7335752,7.0815372 L17.7413735,10.0858736 C17.827497,10.1374323 17.8802142,10.2304339 17.8802142,10.330811 C17.8802142,10.431188 17.827497,10.5241897 17.7413735,10.5757483 L12.4401071,13.7565081 L7.13884074,10.5757483 C7.05271722,10.5241897 7,10.431188 7,10.330811 C7,10.2304339 7.05271722,10.1374323 7.13884074,10.0858736 L12.1460681,7.0815372 C12.3270206,6.97282093 12.5531936,6.97282093 12.7341461,7.0815372 L12.7335752,7.0815372 Z"
                    id="形状"
                    fill="#FFFFFF"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon *ngSwitchCase="'char'">
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="控件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="表格/内容/条款" transform="translate(-43.000000, -12.000000)">
              <g id="编组" transform="translate(17.000000, 12.000000)">
                <g id="编组" transform="translate(26.000000, 0.000000)">
                  <rect id="矩形" fill="#21BC29" x="0" y="0" width="24" height="24" rx="4"></rect>
                  <path
                    d="M9.66666667,7.33333333 L17.25,7.33333333 L17.25,8.5 L9.66666667,8.5 L9.66666667,7.33333333 Z M6.75,7.04166667 L8.5,7.04166667 L8.5,8.79166667 L6.75,8.79166667 L6.75,7.04166667 Z M6.75,11.125 L8.5,11.125 L8.5,12.875 L6.75,12.875 L6.75,11.125 Z M6.75,15.2083333 L8.5,15.2083333 L8.5,16.9583333 L6.75,16.9583333 L6.75,15.2083333 Z M9.66666667,11.4166667 L17.25,11.4166667 L17.25,12.5833333 L9.66666667,12.5833333 L9.66666667,11.4166667 Z M9.66666667,15.5 L17.25,15.5 L17.25,16.6666667 L9.66666667,16.6666667 L9.66666667,15.5 Z"
                    id="形状"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
    </ng-container>
  `
})
export class MFieldIconComponent {
  @Input() mType: EMFieldCombineType = EMFieldCombineType.char;
}
